<template>
  <Section>
    <BarChart style="height: 300px" :chartData="chartData" :options="options" />
  </Section>
</template>

<script>
  import { Section } from '@/components/pages'
  import { BarChart } from 'vue-chart-3';

  function truncate(s, l) {
    return s.length < l ? s : s.substring(0, l-1) + '...'
  }

  export default {
    name: 'DashboardBarChart',

    props: ['data', 'labels', 'title'],
    
    components: { Section, BarChart },

    computed: {
      chartData() {
        return {
          labels: this.labels.map(l => truncate(l, 16)),
          datasets: [
            {
              backgroundColor: 'rgba(125,149,169,0.2)',
              borderColor: 'rgb(125,149,169)',
              borderWidth: 1,
              data: this.data[0],
              label: 'Unopened',
            },
            {
              backgroundColor: 'rgba(41, 98, 255, 0.2)',
              borderColor: 'rgb(41, 98, 255)',
              borderWidth: 1,
              data: this.data[1],
              label: 'Claimed',
            },
            {
              backgroundColor: 'rgba(183,28,28,0.2)',
              borderColor: 'rgb(183,28,28)',
              borderWidth: 1,
              data: this.data[2],
              label: 'Missed',
            },
          ],
        }
      },

      options() {
        return {
          // indexAxis: 'y',
          onClick: this.handleClick,

          plugins: {
            legend: { display: true, },
            title: { display: true, text: this.title },
            tooltip: { enabled: false },
          },
          
          responsive: true, 
        
          scales: {
            x: {
              stacked: true,
            },
            y: {
              stacked: true,
              ticks: { precision: 0, },
            }
          },
        }
      },
    },

    methods: {
      handleClick(_point, event) {
        // ignore clicks outside the bars
        if (event.length > 0) {
          const clicked = event[0].index

          if(clicked != this.current) {
            this.current = clicked
            this.$emit('drill', clicked)
          } else {
            this.current = -1
            this.$emit('clear')
          }
        }
      }
    },
  }
</script>